export default __webpack_public_path__ + "static/sparta-84881031e41c1d21d77389ab277d9969.png";